import { computed, ref } from 'vue'
import type { DevelopmentTools } from '@threadline/shared'

/**
 * Whether this deployment exposes the development panel, and where the local inboxes are.
 *
 * The backend decides, and it answers `null` unless `DEVELOPMENT_TOOLS_ENABLED` is set.
 * The frontend deliberately does not decide this for itself: `import.meta.env.DEV` is
 * settled when the bundle is built, and one built bundle serves every deployment.
 */
const developmentToolsReference = ref<DevelopmentTools | null>(null)

export function setDevelopmentTools(developmentTools: DevelopmentTools | null): void {
  developmentToolsReference.value = developmentTools
}

export function useDevelopmentTools() {
  return {
    developmentTools: computed(() => developmentToolsReference.value),
    developmentToolsEnabled: computed(() => developmentToolsReference.value !== null),
  }
}
